import React from 'react';
import { Card, Panel, Button } from '@/components/Bicester';
import Toolbar from '../components/Toolbar';
import { FieldArray, FormikContextType } from 'formik';
import { LeaseContext } from '.';
import { IconButton } from 'rsuite5';
import Image from '@/components/Bicester/Image';

const GoodsForm = ({ formik }: { formik: FormikContextType<any> }) => {
  const { leaseBasic } = React.useContext(LeaseContext);

  return (
    <Panel leftShadow>
      <Card smDivider>
        <FieldArray name="lease_items">
          {({ insert, remove, push }) => (
            <>
              <Toolbar
                title="租赁物品"
                handleAdd={() => push({ item_type: null, item_amount: '1' })}
                handleReset={() =>
                  formik.setFieldValue('lease_items', [
                    {
                      item_type: null,
                      item_amount: '1',
                    },
                  ])
                }
              />
              <div className="flex-1 flex flex-wrap">
                {formik.values.lease_items.length > 0 &&
                  formik.values.lease_items.map((item, index) => (
                    <div className="flex w-[25%] relative" key={index}>
                      <Card.Picker
                        label="物品"
                        required
                        formKey={`lease_items.${index}.item_type`}
                        pickerData={leaseBasic.item_type}
                        disabledItemValues={
                          formik.values?.lease_items?.map((item) => item.item_type) ?? []
                        }
                        placement="topStart"
                        searchable
                      />
                      <div className="flex items-center ml-[5px] w-[40px]">
                        <Card.Input
                          inputStyle={{ textAlign: 'center', padding: 0 }}
                          inputType="number"
                          formKey={`lease_items.${index}.item_amount`}
                        />
                      </div>
                      <IconButton
                        className={`w-[17px] h-[17px] ml-[5px] ${
                          index === 0 && formik.values.lease_items.length <= 1 ? 'invisible' : ''
                        }`}
                        style={{
                          position: 'absolute',
                          top: 0,
                          right: -22,
                          height: 47,
                          zIndex: 1,
                        }}
                        onClick={() => remove(index)}
                      >
                        <Image src="/resources/images/delete.svg" />
                      </IconButton>
                    </div>
                  ))}
              </div>
            </>
          )}
        </FieldArray>
      </Card>
      <div className="flex justify-end mt-[20px]">
        <Button type="submit" className="px-[70px]">
          确认提交
        </Button>
      </div>
    </Panel>
  );
};

export default GoodsForm;
